import { Box } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import {
  FinanceComplianceExtraFieldConfig,
  FinanceFinancialDocumentComplianceExtraFieldsConfig,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ComplianceExtraFieldSelector } from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel/ComplianceExtraFieldSelector'
import { sortedComplianceExtraFieldsForContext } from 'modules/finance/components/Invoices/SaleInvoicesUpsertSidepanel/lib/complianceExtraFields'

import { SectionTitle } from './_SectionTitle'
import { SaleInvoiceFormFields } from './types'

interface ComplianceExtraFieldsSectionProps {
  form: FormikProps<SaleInvoiceFormFields>
  isCreditNote: boolean
  readOnly?: boolean
  complianceExtraFieldsConfigs: FinanceFinancialDocumentComplianceExtraFieldsConfig[]
}

export const ComplianceExtraFieldsSection: React.FC<ComplianceExtraFieldsSectionProps> = ({
  form,
  isCreditNote,
  readOnly = false,
  complianceExtraFieldsConfigs,
}) => {
  const findComplianceExtraFieldConfigByCountry = (
    country?: string
  ): FinanceFinancialDocumentComplianceExtraFieldsConfig | undefined => {
    return complianceExtraFieldsConfigs.find((config) => config.countryCode === country)
  }

  const complianceExtraFieldsConfig = findComplianceExtraFieldConfigByCountry(
    form.values.legalEntity?.country
  )

  const documentComplianceExtraFieldsConfig = complianceExtraFieldsConfig?.fields
    ? sortedComplianceExtraFieldsForContext(complianceExtraFieldsConfig?.fields, 'document')
    : []

  if (documentComplianceExtraFieldsConfig.length === 0) {
    return null
  }

  const handleOnChangeComplianceExtraField = (
    complianceExtraFieldConfig: FinanceComplianceExtraFieldConfig,
    value: string
  ) => {
    const complianceExtraFieldIndex = form.values.complianceExtraFields?.fields.findIndex(
      (item) => item.name === complianceExtraFieldConfig.name
    )
    if (complianceExtraFieldIndex !== -1) {
      form.setFieldValue(`complianceExtraFields.fields.${complianceExtraFieldIndex}.value`, value)
    } else {
      form.setFieldValue('complianceExtraFields', {
        ...form.values.complianceExtraFields,
        fields: [
          ...(form.values.complianceExtraFields?.fields || []),
          {
            name: complianceExtraFieldConfig.name,
            value: value,
            mandatoryForStandardInvoice: complianceExtraFieldConfig.mandatoryForStandardInvoice,
            mandatoryForCreditNote: complianceExtraFieldConfig.mandatoryForCreditNote,
          },
        ],
      })
    }
  }

  return (
    <Box paddingTop="s16" paddingBottom="s16" gap="s16">
      <SectionTitle title={i18n.t('finance.sale_invoices.form.compliance_fields.title')} />
      <Box width="full" flexDirection="column" gap="s24">
        {documentComplianceExtraFieldsConfig.map((complianceExtraFieldConfig, ind) => {
          return (
            <ComplianceExtraFieldSelector
              isCreditNote={isCreditNote}
              mandatory={
                isCreditNote
                  ? complianceExtraFieldConfig.mandatoryForCreditNote
                  : complianceExtraFieldConfig.mandatoryForStandardInvoice
              }
              key={ind}
              readOnly={readOnly}
              complianceExtraFieldsConfigsField={complianceExtraFieldConfig}
              complianceExtraFields={form.values.complianceExtraFields?.fields || []}
              onChange={(value) => {
                handleOnChangeComplianceExtraField(complianceExtraFieldConfig, value)
              }}
              error={
                form.values.customComplianceExtraFieldErrors?.document[
                  complianceExtraFieldConfig.name
                ]
              }
            />
          )
        })}
      </Box>
    </Box>
  )
}
